import { IconButton } from '@mui/material'
import { useIsDesktopSize } from '$common/react-hooks/layout'
import { VideoSettingsIcon } from '$common/icons/video-settings'
import { VideoPreviewTypes } from '$comp/_app/components/chat/components/footer/components/send-field/send-field.type'

export function VideoPreviewButtonBar({
  setVideoPreviewMode,
}: {
  setVideoPreviewMode: (mode: VideoPreviewTypes) => unknown
}) {
  const isDesktopSize = useIsDesktopSize()

  return (
    <div
      style={{
        backgroundColor: 'black',
        display: 'flex',
        justifyContent: 'center',
        zIndex: 2,
        bottom: 0,
        position: 'absolute',
        width: '100%',

        ...(isDesktopSize && {
          position: 'fixed',
          left: 0,
          right: 0,
        }),
      }}
    >
      <IconButton
        sx={{ width: '64px', height: '64px' }}
        onClick={() => setVideoPreviewMode('compress')}
      >
        <VideoSettingsIcon />
      </IconButton>
    </div>
  )
}
